import { HashtagIcon, RectangleGroupIcon, BookOpenIcon } from '@heroicons/react/16/solid'

export const SidebarList: Array<SidebarItemTypes> = [
    {
        name: 'Components',
        icon: RectangleGroupIcon,
        path: '/'
    },
    {
        name: 'Categories',
        icon: BookOpenIcon,
        path: '/categories'
    },
    {
        name: 'Tags',
        icon: HashtagIcon,
        path: '/tags'
    }
]
